import { render, staticRenderFns } from "./benView.vue?vue&type=template&id=fe7629cc"
import script from "./benView.vue?vue&type=script&lang=js"
export * from "./benView.vue?vue&type=script&lang=js"
import style0 from "./benView.vue?vue&type=style&index=0&id=fe7629cc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports